/**
 * Created by spepa on 10.10.2022
 */

const AchievementsWindow = Prefab.createWindow("achievementswindow", "achievementswindow_prefab_json", {
    bundles: ["achievements"]
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    ACHIEVEMENTS_ITEM_TEXT_COLOR: new cc.Color(160, 65, 53, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ACHIEVEMENTS_ITEM_TEXT: {
        size: 25,
        color: cleverapps.styles.COLORS.ACHIEVEMENTS_ITEM_TEXT_COLOR
    }
});
